import { createTheme } from "@material-ui/core/styles";
import { ShinhanColors } from "src/variable/colors";

// Shinhan MUI theme — maps Material's palette slots onto Shinhan tokens so any
// @material-ui/core component using color="primary" / theme.palette.* renders
// in Shinhan blue instead of the default Material blue (#1976d2).
const shinhanTheme = createTheme({
  palette: {
    primary: {
      lighter: ShinhanColors.primaryFixed,
      light: ShinhanColors.primaryFixedDim,
      main: ShinhanColors.primary,
      dark: ShinhanColors.onPrimaryContainer,
      darker: ShinhanColors.onPrimaryFixed,
      contrastText: ShinhanColors.onPrimary,
    },
    secondary: {
      lighter: ShinhanColors.secondaryContainer,
      light: ShinhanColors.secondaryContainer,
      main: ShinhanColors.secondary,
      dark: ShinhanColors.onSecondaryContainer,
      darker: ShinhanColors.onSecondaryContainer,
      contrastText: ShinhanColors.onSecondary,
    },
    error: {
      lighter: ShinhanColors.errorContainer,
      light: ShinhanColors.errorContainer,
      main: ShinhanColors.error,
      dark: ShinhanColors.onErrorContainer,
      darker: ShinhanColors.onErrorContainer,
      contrastText: ShinhanColors.onError,
    },
    warning: {
      lighter: ShinhanColors.warningContainer,
      light: ShinhanColors.warningContainer,
      main: ShinhanColors.warning,
      dark: ShinhanColors.tertiary,
      darker: ShinhanColors.onTertiaryContainer,
      contrastText: ShinhanColors.onTertiary,
    },
    success: {
      lighter: ShinhanColors.successContainer,
      light: ShinhanColors.successContainer,
      main: ShinhanColors.success,
      dark: ShinhanColors.onSecondaryContainer,
      darker: ShinhanColors.onSecondaryContainer,
      contrastText: ShinhanColors.onSecondary,
    },
    background: {
      default: ShinhanColors.surface,
      paper: ShinhanColors.surface,
      neutral: ShinhanColors.surfaceContainerLowest,
    },
    text: {
      primary: ShinhanColors.onSurface,
      secondary: ShinhanColors.onSurfaceVariant,
      disabled: ShinhanColors.surfaceContainerHighest,
    },
    divider: ShinhanColors.outline,
  },
});

export default shinhanTheme;
